// Prédicats purs (aucune dépendance réseau) : importables par la page ET par les tests
// sans entraîner axios. Miroir de AdminUserScreening côté API.

/** Champs suffisants pour décider du statut « en attente ». */
export interface ScreenableUser {
	id: string;
	email?: string;
	roles: string[];
	source: string;
}

const INTERNAL_EMAIL_DOMAIN = "@bcc.cd";

/** Compte « externe en attente » : aucun rôle attribué ET e-mail hors du domaine interne
 *  @bcc.cd : connexion sociale OU inscription e-mail / mot de passe. Replié dans la liste
 *  « En attente » de la page Utilisateurs (masquée par défaut) ; le serveur l'exclut aussi de
 *  l'annuaire des pickers (assignés de tickets, défauts de catégorie, destinataires de
 *  notifications). Attribuer un rôle vaut approbation ; un compte @bcc.cd reste toujours
 *  visible, même sans rôle. */
export function isPendingExternal(u: ScreenableUser): boolean {
	const noRole = (u.roles?.length ?? 0) === 0;
	const email = (u.email ?? "").trim().toLowerCase();
	const internal = email.endsWith(INTERNAL_EMAIL_DOMAIN);
	return noRole && !internal;
}

/** Libellé humain du fournisseur d'identité, dérivé du préfixe de l'id Auth0. */
export function identityProviderLabel(id: string): string {
	const prefix = (id.split("|")[0] || "").toLowerCase();
	switch (prefix) {
		case "auth0": return "E-mail / mot de passe";
		case "google-oauth2": return "Google";
		case "facebook": return "Facebook";
		case "windowslive": return "Microsoft";
		case "apple": return "Apple";
		case "linkedin": return "LinkedIn";
		default: return prefix || "inconnu";
	}
}
